<template>
     <div class="container">
        <div class="common-header-wrap">
            <mt-header class="common-header" title="甲子隐私政策协议">
                <mt-button icon="back" slot="left" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="help-box">
        <div class="emphasize digest">
            尊敬的甲子用户：我们对《甲子隐私政策》进行了更新。本次更新我们做出了诸多有利于保护您个人信息的调整；明确了我们的产品与/或服务收集、使用及共享个人信息的类型方式和用途；以增强告知或即时提示的方式在收集、使用及共享个人信息时给予用户明示选择权，并在产品设置中允许用户即时撤销授权。明确了用户查询、更正和删除其个人信息的方式。增加了用户账户的锁定/解锁和注销功能，并提供给用户了30日注销后悔期。
        </div>

        <div class="fgx"></div>
        <div class="fgx"></div>

        <h3 class="help-tit01"></h3>

        <div>【特别提示】请仔细阅读《甲子隐私政策》（尤其是加粗划线的内容）并确定了解我们对您个人信息的处理规则。阅读过程中，如您有任何疑问，可联系我们的客服咨询，如您不同意协议中的任何条款，您应立即停止访问甲子。
            阅读协议的过程中，如果您不同意相关协议或其中任何条款约定，您应立即停止使用甲子。
        </div>

        <h3 class="help-tit01">《甲子隐私政策》正文</h3>
        <div>版本更新日期：2017年8月20日</div>
        <div>版本生效日期：2017年8月27日</div>

        <br>
        <div>引言</div>
        <br>

        <div>甲子（“我们”）非常重视用户的隐私和个人信息保护。您在使用我们的产品与/或服务时，我们可能会收集和使用您的相关信息。我们希望通过《甲子隐私政策》（“本隐私政策”）向您说明我们在您使用我们的产品与/或服务时如何收集、使用、保存、共享和转让这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。</div>
        <div>本政策将帮助您了解以下内容：</div>

        <div>1、我们如何收集和使用您的个人信息</div>
        <div>2、我们如何使用 Cookie 和同类技术</div>
        <div>3、我们如何共享、转让、公开披露您的个人信息</div>
        <div>4、我们如何保护和保存您的个人信息</div>
        <div>5、您如何管理个人信息</div>
        <div>6、未成年人信息的保护</div>
        <div>7、通知和修订</div>
        <div>8、如何联系我们</div>


        <strong class="underline">本隐私政策与您所使用的甲子商城服务以及该服务所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，希望您在使用我们的产品或服务前仔细阅读并确认您已经充分理解本政策所写明的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您更好地理解。您使用或在我们更新本隐私政策后（我们会及时提示您更新的情况）继续使用我们的产品或服务，即意味着您同意本隐私政策(含更新版本)内容，并且同意我们按照本隐私政策收集、使用、保存和共享您的相关信息。</strong>
       

        <div class="placeholder-sm"></div>
        <h3 class="help-tit01">一、我们如何收集和使用您的个人信息</h3>
        <div class="help-listq">
            <p>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。<strong>本隐私政策</strong>中涉及的个人信息包括：基本信息（包括个人姓名、住址、个人电话号码）；个人身份信息（包括身份证）；面部特征；网络身份标识信息（包括系统账号、IP地址及与前述有关的密码、口令、口令保护答案）；个人财产信息（交易和消费记录、以及余额、优惠券、等虚拟财产信息）；通讯录；个人上网记录（包括网站浏览记录、软件使用记录、点击记录）；个人常用设备信息（包括硬件型号、设备MAC地址、操作系统类型、软件列表唯一设备识别码（如IMEI/android ID/IDFA/OPENUDID/GUID、SIM卡IMSI信息等在内的描述个人常用设备基本情况的信息）；个人位置信息（包括行程信息、精准定位信息、住宿信息、经纬度等）；</p>
            <p><strong>个人敏感信息</strong>是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，<strong>本隐私政策中涉及的个人敏感信息包括：</strong>您的财产信息（包括交易记录及甲子余额、优惠券等虚拟财产信息）；面部识别特征；个人身份信息（包括身份证）；网络身份识别信息（包括账户名、账户昵称及与前述有关的密码与密码保护问题和答案）；其他信息（包括通讯录、个人电话号码、手机号码、行程信息、网页浏览记录、住宿信息、精准定位信息）。</p>
            <p>我们仅会出于以下目的，收集和使用您的个人信息：</p>
            <p><strong>（一）您须授权我们收集和使用您个人信息的情形<br>
                我们的产品或服务包括核心业务功能和附加功能。我们的产品或服务包括一些核心功能，这些功能包含了实现网上购物所必须的功能、改进我们的产品或服务所必须的功能及保障交易安全所必须的功能。<span class="underline">我们可能会收集、保存和使用下列与您有关的信息才能实现上述这些功能。如果您不提供相关信息，您将无法享受我们提供的产品或服务。这些功能包括：</span></strong></p>
            <h3 class="help-tit02">1、实现网上购物所必须的功能</h3>
            <p><strong>（1）用户注册</strong></p>
            <p>您首先需要注册一个甲子账户成为甲子用户。<strong class="underline">当您注册时，您需要至少向我们提供您准备使用的甲子账户名、密码、您本人的手机号码，我们将通过发送短信验证码来验证您的身份是否有效。</strong>您的账户名为您的默认昵称，您可以修改补充您的昵称、您的实名验证相关信息，这些信息均属于您的“账户信息”。您补充的账户信息将有助于我们为您提供个性化的商品推荐和更优的购物体验，但如果您不提供这些补充信息，不会影响您网上购物的基本功能。</p>
            <p><strong>（2）商品信息展示和搜索</strong></p>
            <p><strong class="underline">为了让您快速地找到您所需要的商品，我们可能会收集您使用我们的产品与/或服务的设备信息（包括设备名称、设备型号、设备识别码、操作系统和应用程序版本、语言设置、分辨率、服务提供商网络ID（PLMN））、浏览器类型来为您提供商品信息展示的最优方式。我们也会为了不断改进和优化上述的功能来使用您的上述个人信息。</strong></p>
            <p>您也可以通过搜索来精准地找到您所需要的商品或服务。我们会保留您的搜索内容以方便您重复输入或为您展示与您搜索内容相关联的商品。
            <strong class="underline">请您注意，您的搜索关键词信息无法单独识别您的身份，不属于您的个人信息，我们有权以任何的目的对其进行使用；只有当您的搜索关键词信息与您的其他信息相互结合使用并可以识别您的身份时，则在结合使用期间，我们会将您的搜索关键词信息作为您的个人信息，与您的搜索历史记录一同按照本隐私政策对其进行处理与保护。</strong></p>
            <p><strong>（3）下单</strong></p>
            <p>当您准备对您购物车内的商品进行结算时，甲子系统会生成您购买该商品的订单。<strong class="underline">您需要在订单中至少填写您的收货人姓名、收货地址以及手机号码，同时该订单中会载明订单号、您所购买的商品或服务信息、您应支付的货款金额及支付方式</strong></p>
            <p>上述所有信息构成您的“订单信息”，我们将使用您的订单信息来进行您的身份核验、确定交易、支付结算、完成配送、为您查询订单以及提供客服咨询与售后服务；我们还会使用您的订单信息来判断您的交易是否存在异常以保护您的交易安全。</p>
            <p><strong>（4）支付功能</strong></p>
            <p>在您下单后，您可以选择甲子的关联方或与甲子合作的第三方支付机构（包括甲子支付、微信支付及支付宝支付通道，以下称“支付机构”）所提供的支付服务。支付功能本身并不收集您的个人信息，但我们需要将您的甲子订单号与交易金额信息与这些支付机构共享以实现其确认您的支付指令并完成支付。“关联方”指一方现在或将来控制、受控制或与其处于共同控制下的任何公司、机构以及上述公司或机构的法定代表人。“控制”是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被人民法院认定的方式。</p>
            <p><strong>（5）交付产品或服务功能</strong></p>
            <p>在当您下单并选择在线完成支付后，甲子的关联方或与甲子合作的第三方配送公司（包括邮政、圆通等，以下称“配送公司”）将为您完成订单的交付。您知晓并同意甲子的关联方或与甲子合作的第三方配送公司会在上述环节内使用您的订单信息以保证您的订购的商品能够安全送达。</p>
            <p>我们的配送员在为您提供配送服务的同时，基于某些业务法律上要求实名认证的需求，会协助您完成实名认证。我们在此环节会使用您的身份证通过国家有权认证机构的专有设备对您的身份进行核验，我们并没有收集您的身份证信息，且我们的配送员均须遵守公司保密制度的规定。</p>
            <p><strong>（6）客服与售后功能</strong></p>
            <p>我们的电话客服和售后功能会使用您的账号信息和订单信息。<br>
                为保证您的账号安全，我们的呼叫中心客服和在线客服会使用您的账号信息与您核验您的身份。当您需要我们提供与您订单信息相关的客服与售后服务时，我们将会查询您的订单信息。您有可能会在与我们的客服人员沟通时，提供给出上述信息外的其他信息，如当您要求我们变更配送地址、联系人或联系电话。
            </p>
        </div>

        <h3 class="help-tit01">2、改进我们的产品与/或服务所必须的功能</h3>
        <div class="help-listq">
            <p><strong>我们可能会收集您的订单信息、浏览信息，用来将您感兴趣的商品或服务信息展示给您；或在您搜索时向您展示您可能希望找到的商品。</strong>我们还可能为了提供服务及改进服务质量的合理需要而获得的您的其他信息，包括您与客服联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息，以及您与我们的关联方、我们合作伙伴之间互动时我们获得的相关信息。对于从您的各种设备上收集到的信息，我们可能会将它们进行关联，以便我们能在这些设备上为您提供一致的服务。我们可能会将来自某项服务的信息与来自其他服务的信息结合起来，以便为您提供服务、个性化内容和建议。</p>
        </div>



        <h3 class="help-tit01">3、保障交易安全所必须的功能</h3>
        <div class="help-listq">
            <p>为提高您使用我们的产品与/或服务时系统的安全性，更准确地预防钓鱼网站欺诈和保护账户安全，我们可能会通过了解您的浏览信息、订单信息、您常用的软件信息、设备信息等手段来判断您的账号风险，并可能会记录一些我们认为有风险的链接（“URL”）；我们也会收集您的设备信息对于甲子系统问题进行分析、统计流量并排查可能存在的风险、在您选择向我们发送异常信息时予以排查。</p>
            <p><strong>（二）您可选择是否授权我们收集和使用您的个人信息的情形</strong></p>
            <p>1、为使您购物更便捷或更有乐趣，从而提升您在甲子的网上购物体验，我们的以下附加功能中可能会收集和使用您的个人信息。<strong>如果您不提供这些个人信息，您依然可以进行网上购物，但您可能无法使用这些可以为您所带来购物乐趣的附加功能或在购买某些商品时需要重复填写一些信息。</strong></p>
            <p><strong>（三）您充分知晓，以下情形中，我们收集、使用个人信息无需征得您的授权同意：</strong></p>
            <p>
                <strong class="underline">
                1、与国家安全、国防安全有关的；<br>
                2、与公共安全、公共卫生、重大公共利益有关的；<br>
                3、与犯罪侦查、起诉、审判和判决执行等有关的；<br>
                4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br>
                5、所收集的个人信息是个人信息主体自行向社会公众公开的；<br>
                6、从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；<br>
                7、根据您的要求签订合同所必需的；<br>
                8、用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；<br>
                9、为合法的新闻报道所必需的；<br>
                10、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；<br>
                11、法律法规规定的其他情形。
                </strong>
            </p>
            <p><strong>（四）我们从第三方获得您个人信息的情形</strong></p>
            <p>我们可能从第三方获取您授权共享的账户信息（头像、昵称），并在您同意本隐私政策后将您的第三方账户与您的甲子账户绑定，使您可以通过第三方账户直接登录并使用我们的产品与/或服务。我们会将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。</p>
            <p><strong>（五）您个人信息使用的规则</strong></p>
            <p>
                1、我们会根据本隐私政策的约定并为实现我们的产品与/或服务功能对所收集的个人信息进行使用。<br>
                2、在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。<strong class="underline">请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以商业化的利用。</strong><br>
                3、<strong class="underline">请您注意，您在使用我们的产品与/或服务时所提供的所有个人信息，除非您删除或通过系统设置拒绝我们收集，否则将在您使用我们的产品与/或服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除您的个人信息。</strong><br>
                4、我们会对我们的产品与/或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品与/或服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。<br>
                5、当我们展示您的个人信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏，以保护您的信息安全。<br>
                6、当我们要将您的个人信息用于本政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会通过您主动做出勾选的形式事先征求您的同意。
            </p>


        </div>



        <h3 class="help-tit01">二、我们如何使用 Cookie 和同类技术</h3>
        <div class="help-listq">
            <p><strong>（一）Cookies的使用</strong></p>
            <p>1、为实现您联机体验的个性化需求，使您获得更轻松的访问体验。我们会在您的计算机或移动设备上发送一个或多个名为Cookies的小数据文件，指定给您的Cookies 是唯一的，它只能被将Cookies发布给您的域中的Web服务器读取。我们向您发送Cookies是为了简化您重复登录的步骤、存储您的购物偏好或您购物车中的商品等数据进而为您提供购物的偏好设置、帮助您优化对广告的选择与互动、帮助判断您的登录状态以及账户或数据安全。</p>
            <p>2、我们不会将 Cookies 用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookies。您可以清除计算机上保存的所有 Cookies，大部分网络浏览器会自动接受Cookies，但您通常可根据自己的需要来修改浏览器的设置以拒绝 Cookies；另外，您也可以清除软件内保存的所有Cookies。但如果您这么做，您可能需要在每一次访问甲子网站时亲自更改用户设置，而且您之前所记录的相应信息也均会被删除，并且可能会对您所使用服务的安全性有一定影响。</p>
            <p><strong>（二）网络Beacon和同类技术的使用</strong></p>
            <p>除 Cookie 外，我们还会在网站上使用网络Beacon等其他同类技术。我们的网页上常会包含一些电子图像（称为"单像素" GIF 文件或 "网络 beacon"）。我们使用网络beacon的方式有：<br>
                1、通过在甲子网站上使用网络beacon，计算用户访问数量，并通过访问 cookie 辨认注册的甲子用户。&nbsp;<br>
                2、通过得到的cookies信息，为您提供个性化服务。
            </p>
        </div>



        <h3 class="help-tit01">三、我们如何共享、转让、公开披露您的个人信息</h3>
        <div class="help-listq">
            <p><strong>（一）共享</strong></p>
            <p>
                <strong>1、我们不会与甲子以外的任何公司、组织和个人共享您的个人信息，但以下情况除外：</strong><br>
                （1）事先获得您明确的同意或授权；<br>
                （2）根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行提供；<br>
                （3）在法律法规允许的范围内，为维护甲子、甲子的关联方或合作伙伴、您或其他甲子用户或社会公众利益、财产或安全免遭损害而有必要提供；<br>
                （4） 只有共享您的信息，才能实现我们的产品与/或服务的核心功能或提供您需要的服务；<br>
                （5）应您需求为您处理您与他人的纠纷或争议；<br>
                （6）符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；<br>
                （7）基于学术研究而使用；<br>
                （8）基于符合法律法规的社会公共利益而使用。
            </p>
            <p><strong>2、我们可能会将您的个人信息与我们的关联方共享。但我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。我们的关联方如要改变个人信息的处理目的，将再次征求您的授权同意。</strong></p>
            <p><strong>3、我们可能会向合作伙伴等第三方共享您的订单信息、账户信息、设备信息以及位置信息，以保障为您提供的服务顺利完成。但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。</strong>我们的合作伙伴包括以下类型：</p>
            <p>（1）商品或技术服务的供应商。<strong class="underline">我们可能会将您的个人信息共享给支持我们功能的第三方。</strong>这些支持包括为我们的供货或提供基础设施技术服务、物流配送服务、支付服务、数据处理等。我们共享这些信息的目的是可以实现我们产品与/或服务的核心购物功能，比如我们必须与物流服务提供商共享您的订单信息才能安排送货；或者我们需要将您的订单号和订单金额与第三方支付机构共享以实现其确认您的支付指令并完成支付等。</p>
            <p>（2）第三方商家。<strong class="underline">我们必须将您的订单信息与交易有关的必要信息与第三方商家共享来实现您向其购买商品或服务的需求，并促使其可以完成后续的售后服务。</strong></p>
            <p>（3）委托我们进行推广的合作伙伴。有时我们会代表其他企业向使用我们产品与/或服务的用户群提供促销推广的服务。<strong class="underline">我们可能会使用您的个人信息以及您的非个人信息集合形成的间接用户画像与委托我们进行推广的合作伙伴（“委托方”）共享，但我们仅会向这些委托方提供推广的覆盖面和有效性的信息，而不会提供您的个人身份信息，或者我们将这些信息进行汇总，以便它不会识别您个人。</strong>比如我们可以告知该委托方有多少人看了他们的推广信息或在看到这些信息后购买了委托方的商品，或者向他们提供不能识别个人身份的统计信息，帮助他们了解其受众或顾客。</p>
            <p>4、对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。为了保障数据在第三方安全可控，我们推出了云鼎服务，在云端提供安全可靠的数据使用和存储环境，确保用户数据的安全性。在个人敏感数据使用上，我们要求第三方采用数据脱敏和加密技术，从而更好地保护用户数据。</p>
            <p>5、为了遵守法律、执行或适用我们的使用条件和其他协议，或者为了保护甲子、您或其他甲子客户的权利及其财产或安全，比如为防止欺诈等违法活动和减少信用风险，而与其他公司和组织交换信息。不过,这并不包括违反本隐私政策中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的个人信息。</p>

            <p><strong>（二）转让</strong></p>
            <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：<br>
                1、事先获得您明确的同意或授权；<br>
                2、根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；<br>
                3、符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；<br>
                <strong class="underline">4、在涉及合并、收购、资产转让或类似的交易时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则,我们将要求该公司、组织重新向您征求授权同意。</strong>
            </p>
            <p><strong>（三）公开披露</strong></p>
            <p>我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会公开披露您的个人信息：<br>
                1、根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；<br>
                2、根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。在法律法规许可的前提下，我们披露的文件均在加密密钥的保护之下。</p>
        </div>



        <h3 class="help-tit01">四、我们如何保护和保存您的个人信息</h3>
        <div class="help-listq">
            <p><strong>（一）我们保护您个人信息的技术与措施</strong><br>
                我们非常重视个人信息安全，并采取一切合理可行的措施，保护您的个人信息：<br>
                <strong>1、数据安全技术措施</strong><br>
                我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改,避免数据的损坏或丢失。<br>
                甲子的网络服务采取了传输层安全协议等加密技术，通过https等方式提供浏览服务，确保用户数据在传输过程中的安全。<br>
                甲子采取加密技术对用户个人信息进行加密保存，并通过隔离技术进行隔离。<br>
                在个人信息使用时，例如个人信息展示、个人信息关联计算，我们会采用包括内容替换、SHA256在内多种数据脱敏技术增强个人信息在使用中安全性。<br>
                甲子采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用。<br>
                甲子采用代码安全自动检查、数据访问日志分析技术进行个人信息安全审计。

            </p>
            <p><strong>2、甲子为保护个人信息采取的其他安全措施</strong></p>
            <p>甲子通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用。<br>
                甲子通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控制。<br>
                甲子建立数据安全委员会并下设信息保护专职部门、数据安全应急响应组织来推进和保障个人信息安全。<br>
                安全认证和服务。我们存储您个人数据的底层云技术取得了数据中心联盟颁发的“可信云”认证三级认证、通过了公安部安全等级保护三级认证，同时还获得了ISO27000认证。<br>
                加强安全意识。我们还会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
            </p>
            <p><strong>3、我们仅允许有必要知晓这些信息的甲子及甲子关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与甲子的合作关系。</strong>我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与甲子的合作关系。</p>
            <p><strong>4、我们会采取一切合理可行的措施，确保未收集无关的个人信息。</strong>我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</p>
            <p>5、我们还在用户数据保护上做了一些创造性工作<br>
                在甲子配送体系，采用了独特的“微笑面单”，避免用户敏感数据在配送环节的暴露，同时,大力强化对甲子物流员工的数据安全培训和要求，提高物流员工保护用户隐私数据的意识。
            </p>
            <p>6、互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件等与其他用户的交流方式无法确定是否完全加密，我们建议您使用此类工具时请使用复杂密码，并注意保护您的个人信息安全。</p>
            <p>7、互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</p>
            <p><strong>8、安全事件处置</strong><br></p>
            <p>在通过甲子网站与第三方进行网上商品或服务的交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址等。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。</p>
            <p>为应对个人信息泄露、损毁和丢失等可能出现的风险，甲子制定了多项制度，明确安全事件、安全漏洞的分类分级标准及相应的处理流程。甲子也为安全事件建立了专门的应急响应团队，按照安全事件处置规范要求，针对不同安全事件启动安全预案，进行止损、分析、定位、制定补救措施、联合相关部门进行溯源和打击。</p>
            <p>在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们同时将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
            <p><strong>（二）您个人信息的保存</strong></p>
            <p>1、您的个人信息将全被存储于中华人民共和国境内。如您使用跨境交易服务，且需要向境外传输您的个人信息完成交易的，我们会单独征得您的授权同意并要求接收方按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理这些个人信息。</p>
            <p><strong>2、除非法律法规另有规定，您的个人信息我们将保存至您账号注销之日后的一个月。</strong>我们承诺这是为了保证您在甲子商城购物的消费者权益，您个人信息在甲子商城须保存的最短期间。当您的个人信息超出我们所保存的期限后，我们会对您的个人信息进行删除或匿名化处理。</p>
            <p><strong class="underline">3、请您注意，当您成功申请注销甲子账户后，我们给予您自注销之日起一个月的“后悔期”，在这个期间内您可以随时申请恢复您已经注销的甲子账户。为了实现您恢复您甲子账户的功能，我们将不会在“后悔期”内对您的个人信息进行删除或匿名化处理。如您在“后悔期”内没有要求恢复您的甲子账户或您明确向我们表述不再恢复您的甲子账户，我们将对您的个人信息进行删除或匿名化处理。</strong></p>
            <p><strong class="underline">4、如果我们终止服务或运营，我们会至少提前三十日向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。</strong></p>


        </div>



        <h3 class="help-tit01">五、您如何管理您的个人信息</h3>
        <div class="help-listq">
            <p>甲子非常重视您对个人信息的关注，并尽全力保护您对于您个人信息访问、更正、删除以及撤回同意的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：</p>
            <p><strong>1、访问和更正您的个人信息</strong></p>
            <p>除法律法规规定外，您有权随时访问和更正您的个人信息，具体包括：</p>
            <p>（1）您的账户信息</p>
            <p>（2）您的收货信息</p>
            <p>（3）您的订单信息</p>
            <p>（4）您的浏览信息</p>
            <p>（5）您的评论信息</p>
            <p>（6）您的发票信息</p>
            <p>（7）您的档案信息</p>
            <p>（8）对于您在使用我们的产品与/或服务过程中产生的其他个人信息需要访问或更正，请随时联系我们。我们会根据本隐私政策所列明的方式和期限响应您的请求。</p>
            <p>（9）您无法访问和更正的个人信息：除上述列明的信息外，您的部分个人信息我们还无法为您提供访问和更正的服务，这些信息主要是为了提升您的用户体验和保证交易安全所收集的您的设备信息、您使用附加功能时产生的个人信息。上述信息我们会在您的授权范围内进行使用，您无法访问和更正，但您可联系我们进行删除或做匿名化处理。</p>
            <p><strong>2、删除您的个人信息</strong></p>
            <p>您在我们的产品与/或服务页面中可以直接清除或删除的信息，包括订单信息、浏览信息、收货地址信息；</p>
            <p><strong>在以下情形中，您可以向我们提出删除个人信息的请求：</strong><br></p>
            <p>（1）如果我们处理个人信息的行为违反法律法规；<br>
                （2）如果我们收集、使用您的个人信息，却未征得您的同意；<br>
                （3）如果我们处理个人信息的行为违反了与您的约定；<br>
                （4）如果您注销了甲子账户；<br>
                （5）如果我们终止服务及运营。<br>
                若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。
            </p>
            <p><strong>3、改变您授权同意的范围或撤回您的授权</strong></p>
            <p><strong class="underline">您可以通过删除信息、关闭设备功能、在甲子网站或软件中进行隐私设置等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销账户的方式，撤回我们继续收集您个人信息的全部授权。</strong></p>
            <p><strong class="underline">请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。</strong></p>
            <p><strong>4、注销账户</strong></p>
            <p><strong class="underline">您可以在我们的产品中直接申请注销账户。并依据您的要求，除法律法规另有规定外，我们将删除您的个人信息。</strong></p>
        </div>

        <h3 class="help-tit01">六、未成年人的个人信息保护</h3>
        <div class="help-listq">
            <p>1、甲子非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的产品与/或服务前，应事先取得您家长或法定监护人的书面同意。甲子根据国家相关法律法规的规定保护未成年人的个人信息。</p>
            <p>2、对于经父母或法定监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。</p>
            <p>3、如果我们发现自己在未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。</p>
        </div>



        <h3 class="help-tit01">七、通知和修订</h3>
        <div class="help-listq">
            <p>1、为给您提供更好的服务以及随着甲子业务的发展，本隐私政策也会随之更新。但未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。我们会通过在甲子网站、甲子移动端上发出更新版本并在生效前通过网站公告或以其他适当方式提醒您相关内容的更新，也请您访问甲子以便及时了解最新的隐私政策。</p>
            <p>2、对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信或在浏览页面做特别提示等方式，说明隐私政策的具体变更内容）。<br>
                本政策所指的重大变更包括但不限于：<br>
                （1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；<br>
                （2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；<br>
                （3）个人信息共享、转让或公开披露的主要对象发生变化；<br>
                （4）您参与个人信息处理方面的权利及其行使方式发生重大变化；<br>
                （5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；<br>
                （6）个人信息安全影响评估报告表明存在高风险时。</p>
            <p>3、我们还会将本策略的旧版本存档，供您查阅。</p>
        </div>


        <a id="contact"></a>
        <h3 class="help-tit01">八、如何联系我们</h3>
        <div class="help-listq">
            <p>1、如您对本隐私政策或您个人信息的相关事宜有任何问题、意见或建议，请通过访问在线客服系统拨打我们的任何一部客服电话等多种方式与我们联系。</p>
            <p>2、我们设立了个人信息保护专职部门（或个人信息保护专员），400-777-5560可以通过与其联系。</p>
            <p>3、一般情况下，我们将在三十天内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及工商等监管部门进行投诉或举报。</p>
            <p>注：本《甲子隐私政策》版本更新日期为2017年8月20日，将于2017年8月27日正式生效，在2017年8月20日至2017年8月27日期间，如您认为更新的《甲子隐私政策》对您更为有利，我们同意双方适用新的《甲子隐私政策》内容。</p>
        </div>


        <h3 class="help-tit01">附件一：《甲子账户注销须知》</h3>
        <div class="help-listq">
            <p>您在申请注销流程中点击下一步前，应当认真阅读《甲子账户注销须知》（以下称“《注销须知》”）。<strong>请您务必审慎阅读、充分理解协议中相关条款内容，其中包括：</strong></p>
            <p><strong>
                1、与您约定免除或限制责任的条款；<br>
                2、其他以粗体下划线标识的重要条款。
            </strong></p>
            <p>如您对本《注销须知》有任何疑问，可拨打我们的客服电话联系客服400-777-5560</p>
            <p><strong>【特别提示】</strong>当您按照注销页面提示填写信息、阅读并同意本《注销须知》及相关条款与条件且完成全部注销程序后，即表示您已充分阅读、理解并接受本《注销须知》的全部内容。
                阅读本《注销须知》的过程中，如果您不同意相关任何条款和条件约定，请您立即停止账户注销程序。</p>
            <p><strong>亲爱的甲子个人消费者用户：</strong></p>
            <p>我们对您注销甲子账户的决定深表遗憾和歉意。<br>
                我们在此善意地提醒您，<strong>您注销账户的行为会给您的售后维权带来诸多不便，且注销甲子账户后，您的个人信息我们只会在甲子商城的前台系统中去除，使其保持不可被检索、访问的状态，或对其进行匿名化处理。您知晓并理解，根据法律法规规定，相关交易记录可能须在甲子后台保存5年甚至更长的时间。</strong></p>
            <p>
                <strong>如果您仍执意注销账户，您的账户需同时满足以下条件：</strong><br>
                （1）在最近一个月内，账户没有进行更改密码、更改绑定信息等敏感操作，账户没有被盗、被封等风险；<br>
                （2）账户在甲子商城系统中无资产（包括但不限于账户余额、优惠券等）、无拍卖保证金、无欠款；<br>
                （3）账户内无未完成的订单、服务，且所有订单完成达一年以上；<br>
                （4）在甲子商城没有过使用该账户激活店铺的记录；<br>
                （5）账户无任何纠纷，包括投诉举报或被投诉举报；<br>
                （6）账户为正常使用中的账户且无任何账户被限制的记录；<br>
                （7）账户对应的甲子支付账户已注销，且已妥善处理了甲子支付账户下的所有问题；<br>
                （8）账户已经解除与其他网站、其他APP的授权登录或绑定关系。
            </p>
            <!-- <p>3. 如果您的甲子账户同时是甲子平台商家店铺的绑定账户名，您需先解除相关绑定；</p> -->
            <p>3 .在甲子账户注销期间，如果您的甲子账户涉及争议纠纷，包括但不限于投诉、举报、诉讼、仲裁、国家有权机关调查等，甲子有权自行终止本甲子账户的注销而无需另行得到您的同意。</p>
            <p>
                <strong>4. 注销甲子账户，您将无法再使用本甲子账户，也将无法找回您甲子账户中及与账户相关的任何内容或信息，</strong>包括但不限于：<br>
                （1）您将无法登录、使用本甲子账户；<br>
                （2）本甲子账户的个人资料和历史信息（包括但不限于用户名、头像、购物记录、关注信息等）都将无法找回；<br>
                （3）您通过甲子账户使用、授权登录或绑定甲子账户后使用的甲子相关或第三方的其他服务的所有记录将无法找回。您将无法再登录、使用前述服务，您曾获得的余额、优惠券、积分、资格、订单及其他卡券等视为您自行放弃，将无法继续使用。<strong>您理解并同意，甲子无法协助您重新恢复前述服务。请您在提交注销申请前，务必先了解您须解绑的其他相关账户信息，具体可与我们的客服联系。</strong>
            </p>
            <p><strong>5. 注销本甲子账户并不代表本甲子账户注销前的账户行为和相关责任得到豁免或减轻。</strong></p>
        </div>




        <h3 class="help-tit01">附件二：<br>上一版《甲子隐私政策》</h3>
        <div class="help-listq">
            <p>甲子（以下或称“我们”）注重保护用户个人信息及个人隐私。本隐私政策解释了用户（“您”）个人信息收集（以下或称“信息”）和使用的有关情况，本隐私政策适用于甲子向您提供的所有相关服务（包括但不限于电子商务、网络资讯服务等，以下称“甲子服务”或“服务”）。<strong>如果您不同意本隐私政策的任何内容，您应立即停止使用甲子服务。当您使用甲子提供的任一服务时，即表示您已同意我们按照本隐私政策来合法使用和保护您的个人信息。</strong></p>
            <p><strong>一、您个人信息的收集</strong></p>
            <p>我们收集信息是为了向您提供更好以及更个性化的服务，并努力提高您的用户体验。我们收集信息的种类如下：</p>
            <p>
                <strong>1、您向我们提供的信息</strong><br>
                当您注册甲子账户及您在使用相关甲子服务时填写、提交及/或其他任何方式提供的信息，包括您的姓名、性别、出生年月日、身份证号码、电话号码、收货地址、甲子钱包及相关附加信息（如您地址中的所在的省份和城市、邮政编码等）。<strong>您可以选择不提供某一或某些信息，但是这样可能使您无法使用甲子的许多特色服务。</strong>请您理解，我们使用您提供的信息是为了回应您的要求，为您在甲子购物或享受服务提供便利，完善甲子网站以及与您进行信息沟通。另外，我们可能会将您所提供的信息与您的甲子账户关联，用以识别您的身份。
            </p>
            <p>
                <strong>2、我们在您使用服务过程中获得的信息</strong><br>
                为了提高服务质量和用户体验，我们会留存您使用服务以及使用方式的相关信息，这类信息包括：
                <strong>（1）您的浏览器和计算机上的信息。</strong>在您访问甲子网站或使用甲子服务时，甲子系统自动接收并记录的您的浏览器和计算机上的信息（包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据）。<br>
                <strong>（2）您的位置信息。</strong>当您下载或使用甲子、其关联方及合作伙伴开发的应用程序（例如甲子APP），或访问移动网页使用甲子服务时，甲子可能会读取您的位置（大多数移动设备将允许您关闭定位服务，具体建议您联系您的移动设备的服务商或生产商）。<br>
                <strong>（3）您的设备信息。</strong>甲子可能会读取您访问甲子或使用甲子服务时所使用的终端设备的信息，包括但不限于设备型号、设备识别码、操作系统、分辨率、电信运营商等。<br>
                <strong>（4）您的行为或交易信息。</strong>甲子可能会记录您访问甲子或使用甲子服务时所进行的操作以及您在甲子网站上进行交易的相关信息。<br>
                甲子可能会记录您访问甲子或使用甲子服务时所进行的操作以及您在甲子网站上进行交易的相关信息。<br>
                同时，为提高您使用甲子提供的服务的安全性，更准确地预防钓鱼网站欺诈和木马病毒，我们可能会通过了解一些您的网络使用习惯、您常用的软件信息等手段来判断您账户的风险，并可能会记录一些我们认为有风险的链接（“URL”）。<br>
            </p>
            <p><strong>3、来自第三方的信息</strong></p>
            <p><strong>指在您注册甲子账户和使用服务过程中，您授权甲子可向甲子的关联方、合作伙伴获取其所收集的相关信息。</strong>这些信息包括但不限于您的身份信息、行为信息、交易信息、设备信息等，甲子会将此类信息汇总，用于帮助甲子向您提供更好以及更加个性化的服务或更好的预防互联网欺诈。</p>
            <p>
                <strong>您了解并同意，以下信息不适用本隐私政策：</strong><br>
                （1）您在使用甲子提供的搜索服务时输入的关键字信息；<br>
                （2）信用评价、违反法律法规规定或违反甲子平台规则行为及甲子已对您采取的措施；<br>
                （3）应法律法规要求需公示的企业名称等相关工商注册信息以及自然人经营者的信息。<br>
                （4）其他您与甲子或甲子的关联方所签署的协议（包括在线签署的电子协议，例如《甲子用户注册协议》）以及甲子平台规则中明确约定或提示您不适用本隐私政策的与您有关的信息。
            </p>
            <p><strong>二、我们对您个人信息的管理和使用</strong></p>
            <p>
                为向您提供服务、提升我们的服务质量以及优化您的服务体验，我们会在符合法律规定下使用您的个人信息，并主要用于下列用途：<br>
                1、向您提供您使用的各项服务，并维护、改进这些服务。<br>
                2、向您推荐您可能感兴趣的内容，包括但不限于向您发出产品和服务信息，或通过系统向您展示个性化的第三方推广信息，或在征得您同意的情况下与甲子的合作伙伴共享信息以便他们向您发送有关其产品和服务的信息。如您不希望接收上述信息，可通过相应的退订功能进行退订。<br>
                3、我们可能使用您的个人信息以验证身份、预防、发现、调查欺诈、危害安全、非法或违反与我们或其关联方协议、政策或规则的行为，以保护您、其他甲子用户，或我们或其关联方的合法权益。<br>
                4、我们可能会将来自某项服务的个人信息与来自其他服务所获得的信息结合起来，用于为了给您提供更加个性化的服务使用，例如为让您通过购物拥有更广泛的社交圈而使用、共享或披露您的信息。<br>
                5、我们会对我们的服务使用情况进行统计，并可能会与公众或第三方分享这些统计信息，以展示我们的产品或服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。<br>
                6、让您参与有关我们产品及服务的调查。<br>
                7、经您同意或授权的其他用途。
            </p>
            <p><strong>三、您个人信息的分享</strong></p>
            <p>您的个人信息是我们为您提供服务的重要部分，我们会遵循法律规定对您的信息承担保密义务。<strong>除以下情形外，我们不会将您的个人信息披露给第三方：</strong></p>
            <p>
                1、征得您的同意或授权。<br>
                2、根据法律法规的规定或行政或司法机构的要求。<br>
                3、出于实现“我们对您个人信息的管理和使用”部分所述目的，或为履行我们在《甲子用户注册协议》或本隐私政策中的义务和行使我们的权利，向甲子的关联方、合作伙伴或代表甲子履行某项职能的第三方（例如代表我们发出推送通知的通讯服务商、处理银行卡的支付机构等）分享您的个人信息。<br>
                4、如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能产生的权利纠纷。<br>
                5、只有共享您的信息，才能提供您需要的服务，或处理您与他人的纠纷或争议。<br>
                6、您出现违反中国有关法律、法规规定或者违反您与甲子签署的相关协议（包括在线签署的电子协议）或违反相关甲子平台规则时需要向第三方披露的情形。<br>
                7、为维护甲子及其关联方或其他甲子用户的合法权益。<br>
                <strong>随着我们业务的发展，我们及我们的关联方有可能进行合并、收购、资产转让或类似的交易，您的个人信息有可能作为此类交易的一部分而被转移。我们将在转移前通知您。</strong>
            </p>
            <p><strong>四、您个人信息的安全</strong></p>
            <p>甲子严格保护您的个人信息安全。我们使用各种制度、安全技术和程序等措施来保护您的个人信息不被未经授权的访问、篡改、披露或破坏。如果您对我们的个人信息保护有任何疑问，请联系我们的客服。</p>
            <p>在通过甲子网站与第三方进行网上商品或服务的交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址等。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是你的账户及密码发生泄露，请您立即联络我们的客服，以便我们采取相应措施。</p>
            <p><strong>五、访问和更新您的个人信息</strong></p>
            <p><strong>您可以在“我的甲子”页面的“账户设置”菜单中查阅您提交给甲子的所有个人信息，你也可通过上述途径更新除实名认证信息之外的其他个人信息（您的实名认证信息是您通过实名认证时使用的姓名和身份证信息），如您需要变更您的实名认证信息，您可拨打95118服务热线申请变更。</strong></p>
            <p><strong>六、Cookie 及网络 Beacon的使用</strong></p>
            <p>
                1、Cookie的使用<br>
                Cookie是由网页服务器存放在您的访问设备上的文本文件。指定给您的Cookie 是唯一的，它只能被将Cookie发布给您的域中的Web服务器读取。<br>
                甲子使用 Cookie 来帮助您实现您的联机体验的个性化，使您在甲子及其关联方获得更轻松的访问体验。例如，Cookie 会帮助您在后续访问甲子网站时调用您的信息，简化记录您填写个人信息（例如一键登录等）的流程；为您提供安全购物的偏好设置；帮助您优化对广告的选择与互动；保护您的数据安全等。<br>
                您有权接受或拒绝 Cookie。大多数浏览器会自动接受Cookie，但您通常可根据自己的需要来修改浏览器的设置以拒绝 Cookie。如果选择拒绝 Cookie，那么您可能无法完全体验所访问的甲子网站或某些服务的全部功能。
            </p>
            <p>
                2、网络Beacon的使用 <br>
                甲子网页上常会包含一些电子图象（称为"单像素" GIF 文件或 "网络 beacon"），它们可以帮助网站计算浏览网页的用户或访问某些cookie。甲子使用网络beacon的方式有：<br>
                （1）甲子通过在甲子网站上使用网络beacon，计算用户访问数量，并通过访问 cookie 辨认注册用户。<br>
                （2）甲子通过得到的cookie信息，可以在甲子网站提供个性化服务。
            </p>
            <p><strong>七、未成年人的个人信息保护</strong></p>
            <p>甲子非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用甲子服务前，应事先取得您家长或法定监护人的书面同意。甲子根据国家相关法律法规的规定保护未成年人的个人信息。</p>
            <p><strong>八、通知和修订</strong></p>
            <p>为给你提供更好的服务，甲子的业务将不时变化，本隐私政策也将随之调整。甲子会通过在甲子网站、移动端上发出更新版本并提醒您相关内容的更新，也请您访问甲子以便及时了解最新的隐私政策。如果您对于本隐私政策或在使用甲子服务时对于您的个人信息或隐私情况有任何问题，请联系甲子客服并作充分描述，甲子将尽力解决。</p>
        </div>


    </div>
    </div>
</template>
<script>
export default {
    name:'privacyPolicy',
    data() {
        return {
          
        }
    },
    methods:{
       handleTo() {
           this.$router.push({
               name:'privacyPolicy'
           })
       }
    }
}
</script>
<style lang="scss" scoped>
.help-box {
    padding:10px;
    line-height: 1.5;
    font-size: 16px;
}
        .emphasize{
            color: #5182bb;
        }

        .digest{
            position: relative;
            margin-bottom:20px;
        }

        .fgx{
            background: #333;
            width: 100%;
            height: 1px;
            margin: 1px 0;
        }

        strong{
            font-weight: 700;
        }

        .strong{
            font-weight: 700;
        }

        .placeholder-sm{
            height: 10px;
        }

        a{
            color: #06c;
        }
        .underline {
            text-decoration: underline;
        }
        p {
            margin-top:0.5em;
            margin-bottom:0.5em;
        }
</style>